import React from 'react';
import { Button } from '@/components/ui/Button';

interface ErrorBoundaryState {
  error: Error | undefined;
}

// ErrorBoundary must be a class component (React requirement)
export default class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 text-center">
          <span className="text-7xl font-black text-muted-foreground">!</span>
          <h1 className="text-2xl font-bold text-foreground">Ooops!</h1>
          <h3 className="text-muted-foreground">Something went wrong. Please refresh.</h3>
          <Button onClick={() => window.location.reload()}>Refresh</Button>
        </div>
      );
    }
    return this.props.children;
  }
}
